import React, { useState, useEffect } from 'react';
import { Row, Col, Table } from 'antd';
import { PageHeader } from '../components/page-headers/page-headers';
import axios from '../backendService';
import { GlobalUtilityStyle, PaginationStyle } from '../container/styled';
import Cookies from 'js-cookie';

function ReferTeacher() {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const [userData, setUserData] = useState(null);
  const [referredUsers, setReferredUsers] = useState([]);

//   useEffect(() => {
//     const fetchTeacherData = async () => {
//       try {
//         const userId = Cookies.get('transactionId');
//         const response = await axios.get(`/transaction-history/${userId}`);
//         console.log(response.data.data,"ddddd")
        
//        // Set the state with fetched data
//        setData(Array.isArray(response.data.data) ? response.data.data : []);
//       //  setData(response.data.data);
//      } catch (error) {
//        console.error('Error fetching teacher data:', error);
//        // Handle error appropriately
//      }
//    };

//    fetchTeacherData();
//  }, []);

useEffect(() => {
  const fetchTeacherData = async () => {
    try {
      const userId = Cookies.get('transactionId');
      const response = await axios.get(`/transaction-history/${userId}`);
      const data = response.data.data;

      // Transform the data
      const mainUser = { ...data.user, refCode: data.refCode, defaultPoints: data.defaultPoints, totalWalletPoints: data.totalWalletPoints };
      const referredUsers = data.referredUsers.map(user => ({ ...user, referredBy: mainUser.userName }));
      
      // Combine main user and referred users
      const combinedData = [mainUser, ...referredUsers];

      setData(combinedData);
    } catch (error) {
      console.error('Error fetching teacher data:', error);
      setData([]);
    }
  };

  fetchTeacherData();
}, []);

  const columns = [
    {
      title: 'User',
      dataIndex: 'userName',
      key: 'userName',
      align: 'center',
    },
    {
      title: 'My Referral Code',
      dataIndex: 'refCode',
      key: 'refCode',
    },
    // {
    //   title: 'Used Referral Code',
    //   key: 'usedReferralCode',
    //   // render: (text, record) => {
    //   //   return record.user.referral || 'N/A';
    //   render: (text, record) => {
    //     return record.referral || 'N/A'; 
    //   },
    //   align: 'center',
    // },
    // {
    //   title: 'Code Owner',
    //   key: 'referrerUserName',
    //   render: (text, record) => {
    //     // const referrerRecord = data.find((transaction) => transaction.refCode === record.user.referral);
    //     // return referrerRecord ? referrerRecord.userName : 'N/A';
    //     const referrerRecord = data.find((transaction) => transaction.refCode === record.referral); // Changed from record.user.referral
    //   return referrerRecord ? referrerRecord.userName : 'N/A';
    //   },
    // },
    {
      title: 'Default Points',
      dataIndex: 'defaultPoints',
      key: 'defaultPoints',
      align: 'center',
    },
    // {
    //   title: 'My Referrals',
    //   dataIndex: 'referredUsers',
    //   key: 'referredUsers',
    //   render: (referredUsers) => (
    //     <span>
    //       {referredUsers && referredUsers.length ? referredUsers.map((user) => user.userName).join(', ') : 'N/A'}
    //     </span>
    //   ),
    // },
    {
      title: 'Total Points',
      dataIndex: 'totalWalletPoints',
      key: 'totalWalletPoints',
      align: 'center',
    },
  ];

  return (
    <>
      <PageHeader
        className="flex items-center justify-between px-8 xl:px-[15px] pt-7 pb-6 sm:pb-[30px] bg-transparent sm:flex-col"
        title="  "
      />
      <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent">
        <Row gutter={30}>
          <Col xs={24}>
            <>
              <div className="bg-white dark:bg-white10 m-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px]">
                <div className="text-dark dark:text-white87 font-medium text-[17px] flex items-center justify-between gap-[15px] sm:justify-left mb-5">
                  <div className="flex items-center justify-between gap-[15px] w-[150px]">
                    <h1 className="mb-0 flex-shrink-0 text-ellipsis text-[18px] font-semibold sm:text-center">
                      Transaction History
                    </h1>
                  </div>
                </div>
                <div className="mt-0.5">
                  <>
                    <GlobalUtilityStyle>
                      <PaginationStyle>
                        <div className="ant-pagination-custom-style table-responsive hover-tr-none table-th-shape-none table-last-th-text-right table-th-border-none table-head-rounded table-selection-col-pl-25 table-tr-selected-background-transparent table-td-border-none bg-white dark:bg-transparent rounded-[10px] ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-none ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-none">
                          <Table
                            // dataSource={data ? [data] : []} // Ensure dataSource is an array
                            // dataSource={filterData}
                            dataSource={data}
                            // dataSource={data}
                            columns={columns}
                            rowKey={(record) => record._id}
                            pagination={{
                              defaultPageSize: 7,
                              total: data.length,
                              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                              className:
                                '[&>.ant-pagination-total-text]:border-none ssm:[&>.ant-pagination-total-text]:w-full [&>.ant-pagination-total-text]:text-center [&>.ant-pagination-total-text]:text-dark dark:[&>.ant-pagination-total-text]:text-white87 [&>.ant-pagination-total-text]:font-medium [&>.ant-pagination-total-text]:text-[17px md:justify-center',
                            }}
                          />
                        </div>
                      </PaginationStyle>
                    </GlobalUtilityStyle>
                  </>
                </div>
              </div>
            </>
          </Col>
        </Row>
      </main>
    </>
  );
}

export default ReferTeacher;
